document.addEventListener('DOMContentLoaded', function () {

  function blockIfUnchecked(e) {
    // Find the form this button belongs to
    const form = e.target.closest('form[action="/cart/add"]');
    if (!form) return;

    const checkbox = form.querySelector('.handling-fee-checkbox');
    const errorMsg = form.querySelector('.handling-fee-error');

    if (!checkbox) return;

    if (!checkbox.checked) {
      e.preventDefault();
      e.stopImmediatePropagation();
      if (errorMsg) {
        errorMsg.style.display = 'block';
        checkbox.scrollIntoView({ behavior: 'smooth', block: 'center' });
        checkbox.focus();
      }
    } else {
      if (errorMsg) errorMsg.style.display = 'none';
    }
  }

  // Intercept all clicks on Add to Cart buttons
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('button[name="add"], button[type="submit"]');
    if (!btn) return;
    blockIfUnchecked(e);
  }, true); // useCapture=true catches it before Stockmart's AJAX handler

  // Also intercept form submit as fallback
  document.addEventListener('submit', function (e) {
    const form = e.target.closest('form[action="/cart/add"]');
    if (!form) return;
    blockIfUnchecked(e);
  }, true);

});